<template>
  <div id="app">
    <div class="header">
      <img width="100%" height="91px" src="../src/assets/banner.png" />
      <van-divider :style="{ color: '#000', borderColor: '#d3d3d3', padding: '0 10px' }"/>
      <van-field v-model="title" placeholder="标题（30字以内）" maxlength="30" size="large" />
    </div>
    <div class="content">
      <van-divider :style="{ color: '#000', borderColor: '#d3d3d3', padding: '0 10px' }"/>
      <div><Editor ref="editor" v-model="value" @inputDetail="inputDetail"/></div>
      <van-divider :style="{ color: '#000', borderColor: '#d3d3d3', padding: '0 10px' }"/>
      <uploader
        v-model="fileList"
        :url= uploadUrl
        name="image"
        :headers="{
          'custom-header': 'custom-info',
        }"
        :limit="6"
        :limitPrompt="(limit) => `已经上传${limit}张图片嘞！`"
        withCredentials
        @on-change="onChange"
        @on-cancel="onCancel"
        @on-success="onSuccess"
        @on-error="onError"
        @on-delete="onDelete"
      />
      <van-divider :style="{ color: '#000', borderColor: '#d3d3d3', padding: '0 10px' }"/>
      <van-form>
        <van-field 
            v-model="phone" 
            name="phone" 
            :rules="[{ required: true, message: '请填写手机号' }, {validator, message: '手机号格式错误!'}]"
            maxlength="11"
            label="手机号" 
            placeholder="仅用于工作人员联系您" 
        />
      </van-form>
      <van-divider :style="{ color: '#000', borderColor: '#d3d3d3', padding: '0 10px' }"/>
    </div>
    <van-button type="primary" size="large" :round="true" color="#D05652" @click="submit()">提交</van-button
    >
  </div>
</template>

<script>
import Uploader from "vux-uploader-component";
import Editor from "../src/components/Editor.vue";
import { wxShareInit } from "../src/utils/WxShare.js";
import { Button, Field, Toast, Divider,Form  } from "vant";
import axios from "axios";
import { BASE_URL, BASE_SHARE_URL } from '../src/utils/constant.js'

import "vant/lib/cell/style";
import "vant/lib/field/style";
import "vant/lib/button/style";
import "vant/lib/toast/style";
import "vant/lib/divider/style";

export default {
  name: "app",
  components: {
    Uploader,
    Editor,
    [Field.name]: Field,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Divider.name]: Divider,
    [Form.name]: Form,

  },
  data() {
    return {
      title: "",
      phone: "",
      value: "",
      images: "",
      fileList: [],
      uploadUrl:  BASE_URL + "survey/retirementSurvey/doFileUpload",
      shareIconUrl: BASE_SHARE_URL + "static/images/share.png"
    };
  },

  mounted() {
    this.$nextTick(function(){
      try {
        const url = window.location.href.split('#')[0]
        wxShareInit(url, this.shareIconUrl)
     } catch (error) {
       console.error(error)
     }
    })
  },

  methods: {

    validator(val) {
      return /^(((13[0-9]{1})|(14[57]{1})|(15[012356789]{1})|(17[03678]{1})|(18[0-9]{1})|(19[89]{1})|(16[6]{1}))+\d{8})$/.test(val);
    },
    inputDetail(detail) {
      this.value = detail;
    },

    submit() {
      this.getImagesUrlString();
      if (this.title === ""){
        Toast.fail("标题不能为空");
        return
      }

      if (this.value === ""){
        Toast.fail("详情不能为空");
        return
      }

      if (this.phone === ""){
        Toast.fail("手机号不能为空");
        return
      }

      if(this.validator(this.phone)){
          axios({
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            baseURL: BASE_URL,
            url: "/survey/retirementSurvey/addSurvey",
            data: JSON.stringify({
              title: this.title,
              detail: this.value,
              images: this.images,
              telephone: this.phone,
            }),
          }).then((res) => {
            if (res.data.code === "0") {
              Toast.success("提交成功");
              this.clearData();
            } else {
              Toast.fail("提交失败" + res.data.msg);
            }
          })
          .catch((res) => {
            Toast.fail("提交失败" + res.response.data.msg);
          });
      }else {
        Toast.fail("手机号验证失败，请重新确认");
      }

    },

    deleteRemoteImage(deleteItemUrl) {
      axios({
            method: "POST",
            baseURL: BASE_URL,
            url: "/survey/retirementSurvey/doFileDelete",
            params: {
              fileName: deleteItemUrl
            }
          }).then((res) => {
            if (res.data.code === "0") {
              Toast.success("删除成功");
              this.clearData();
            } else {
              Toast.fail("删除失败：" + res.data.msg);
            }
          })
          .catch((res) => {
            Toast.fail("删除失败：" + res.response.data.msg);
          });
    },

    clearData() {
      this.title = "";
      this.phone = "";
      this.fileList = [];
      this.images = "";
      this.value = "";
      this.$refs.editor.clearInput();
    },

    getImagesUrlString() {
      if (this.fileList != null && this.fileList.length > 0){
        for (var i = 0; i < this.fileList.length; i++) {
          this.images += this.fileList[i].fileid + ",";
        }
        this.images = this.images.substring(0, this.images.length - 1);
      }
    },

    onChange(fileItem, fileList) {
      // console.log("on-change: ", fileItem, fileList);
    },
    onCancel() {
      console.log("on-cancel: Sucess");
    },
    onSuccess(res, fileItem) {
      // console.log("on-success: ", res);
      fileItem.fileid = res.data;
    },
    onError(res) {
      // console.log("on-error: ", res);
    },
    onDelete(deleteItem, cb) {
      // console.log("on-delete: ", deleteItem);
      this.deleteRemoteImage(deleteItem.fileid);
      cb && cb();
    },
  },
};
</script>

<style>
body {
  background: #fff;
  margin: 0;
  padding: 0;
}
p {
  margin: 0;
}
ul {
  margin: 0;
  padding: 0;
}

img {
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.header {
  padding: 10px;
}
.content {
  background: #fff;
}
.van-button {
  display: block;
  width: 95%;
  margin: 40px auto;
}
.van-field__label {
  color: #2c3e50;
  font-size: 16px;
}
.van-field__control {
  font-size: 18px;
}
.van-divider {
  margin: 10px 0;
}
.van-cell--large {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
